module.exports = __webpack_public_path__ + "img/5.3cfe52a5.svg";